// This file is automatically generated. Do not edit manually.

import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { ConfiguratorInput } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorInput";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues";
import { ConfigurationCheckpointResult } from "src/api/generated/erp/configurator/checkpoints/model/configurationCheckpointResult";
import { ConfigurationCheckpointDescriptionEntry } from "src/api/generated/erp/configurator/checkpoints/service/configurationCheckpointDescriptionEntry";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ConfigurationCheckpointApi {
	export async function createConfigurationCheckpoint(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		configuratorInput: ConfiguratorInput;
		previousCheckpointPropertyValues: ConfigurationPropertyValues | null | undefined;
	}): Promise<ConfigurationCheckpointResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/checkpoint/createConfigurationCheckpoint",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				configuratorInput: args.configuratorInput,
				previousCheckpointPropertyValues: args.previousCheckpointPropertyValues,
			},
		});
		return response as ConfigurationCheckpointResult;
	}

	export async function generateHistoryDescription(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		configuratorInput: ConfiguratorInput;
		latestCheckpointPropertyValues: ConfigurationPropertyValues | null | undefined;
		checkpoints: Array<ConfigurationCheckpointDescriptionEntry>;
	}): Promise<string> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/checkpoint/generateHistoryDescription",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				configuratorInput: args.configuratorInput,
				latestCheckpointPropertyValues: args.latestCheckpointPropertyValues,
				checkpoints: args.checkpoints,
			},
		});
		return response as string;
	}
}
